import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { lenisStore } from "@/lib/lenisStore";
import { initConsentDefaults } from "@/lib/analytics";
import Landing from "@/pages/Landing";
import Presupuesto from "@/pages/Presupuesto";
import Aparatos from "@/pages/Aparatos";
import Legal from "@/pages/Legal";
import Admin from "@/pages/Admin";
import { CookieBanner } from "@/components/CookieBanner";

function PixelPageView() {
  const location = useLocation();
  useEffect(() => {
    if (typeof window !== "undefined" && typeof window.fbq === "function") {
      window.fbq("track", "PageView");
    }
  }, [location.pathname]);
  return null;
}

function App() {
  useEffect(() => {
    initConsentDefaults();
    const lenis = new Lenis({ lerp: 0.09, anchors: { offset: -88 } });
    lenisStore.current = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      lenisStore.current = null;
    };
  }, []);

  return (
    <BrowserRouter>
      <PixelPageView />
      <Toaster position="top-center" richColors />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/presupuesto" element={<Presupuesto />} />
        <Route path="/aparatos" element={<Aparatos />} />
        <Route path="/aviso-legal" element={<Legal type="aviso" />} />
        <Route path="/privacidad" element={<Legal type="privacidad" />} />
        <Route path="/cookies" element={<Legal type="cookies" />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
      <CookieBanner />
    </BrowserRouter>
  );
}

export default App;
